






import { computed, defineComponent } from '@nuxtjs/composition-api';
import { DEFAULT_ATTRIBUTE_LIMIT } from '~/constants/comparisonProducts';

export default defineComponent({
  name: 'ComparisonTableRow',
  props: {
    showMore: {
      type: Boolean,
      required: true,
    },
    rowNumber: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const isHidden = computed(() => !props.showMore && props.rowNumber > DEFAULT_ATTRIBUTE_LIMIT);

    return {
      isHidden,
    };
  },
});

